import { useQuery } from '@tanstack/react-query';
import { fetch_catalog_product, fetch_catalog_products, type CatalogSearch } from './api';

export function use_catalog_products(params: CatalogSearch, enabled = true) {
  return useQuery({
    queryKey: ['catalog-products', params],
    queryFn: () => fetch_catalog_products(params),
    enabled,
    placeholderData: (prev) => prev,
  });
}

/**
 * One curated master, for its gallery.
 *
 * Enabled only when a listing is actually linked — an unlinked product has no master and
 * firing this for it would 404 on every custom listing in the shop.
 */
export function use_catalog_product(id: string | undefined) {
  return useQuery({
    queryKey: ['catalog-product', id],
    queryFn: () => fetch_catalog_product(id as string),
    enabled: !!id,
    staleTime: 5 * 60_000,
  });
}
